import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=8953b60e&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=8953b60e&prod&lang=scss&scoped=true"
import style1 from "./Service.vue?vue&type=style&index=1&id=8953b60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953b60e",
  null
  
)

export default component.exports